import React from "react";
import Home from "./component/Home/Home";
import Navbar from "./component/Navbar";
import About from "./component/About/About";
import Contact from "./component/Contact/Contact";
import Skill from "./component/Skill/Skill";
import Project from "./component/Project/Project";
import ProjectDetail from "./component/Project/ProjectDetail";
import Footer from "./component/Footer";
import ScrollProgress from "./component/ScrollProgress";

import { Routes, Route } from "react-router-dom";

const App = () => {
  return (
    <div className="main-app" style={{ paddingTop: "68px" }}>
      <ScrollProgress />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/skill" element={<Skill />} />
        <Route path="/project" element={<Project />} />
        <Route path="/project/:id" element={<ProjectDetail />} />
      </Routes>
      <Footer />
    </div>
  );
};

export default App;
